import { environment } from "../environments";
import {
  CheckInvoiceIsraelTokenRequest,
  CheckInvoiceIsraelTokenResponse,
  CompleteIsraelInvoiceAuthRequest,
  CompleteIsraelInvoiceAuthResponse,
} from "../models/IsraelInvoice.model";

const API_BASE_URL = environment.apiUrl;

export class IsraelInvoiceService {
  static async completeAuthorization(
    requestData: CompleteIsraelInvoiceAuthRequest,
  ): Promise<CompleteIsraelInvoiceAuthResponse> {
    const response = await fetch(
      `${API_BASE_URL}BookkeepingDocument/InvoiceIsrael/CompleteAuthorization`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(requestData),
      },
    );

    if (!response.ok) {
      throw new Error(`HTTP ${response.status}`);
    }

    return (await response.json()) as CompleteIsraelInvoiceAuthResponse;
  }

  static async checkToken(
    requestData: CheckInvoiceIsraelTokenRequest,
  ): Promise<CheckInvoiceIsraelTokenResponse> {
    const response = await fetch(
      `${API_BASE_URL}BookkeepingDocument/InvoiceIsrael/CheckToken`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(requestData),
      },
    );

    if (!response.ok) {
      throw new Error(`HTTP ${response.status}`);
    }

    return (await response.json()) as CheckInvoiceIsraelTokenResponse;
  }
}
